import styled from "styled-components";

export const Container = styled.div`
    background-color: ${({ theme }) => theme.white};
    padding: 32px;
    border-radius: 8px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const Title = styled.h1`
    color: ${({ theme }) => theme.purple500};
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.07px;
    text-align: center;
`;

export const VideoContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Buttons = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 20px;

    button {
        width: 300px;
    }
`;
